import React, { useContext, useState } from 'react';
import {
  mergeClasses,
  makeStyles,
  tokens,
  Button,
  Tooltip,
} from '@fluentui/react-components';
import { CheckmarkRegular } from '@fluentui/react-icons';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';

interface IApplyButtonProps {
  onSave: (e: any) => void;
  disabled?: boolean;
  tooltipDescription?: string;
  tooltipEnabled?: boolean;
}

export const useApplyButtonStyles = makeStyles({
  button: {
    paddingTop: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingLeft: tokens.spacingHorizontalSNudge,
    paddingRight: tokens.spacingHorizontalSNudge,
    fontWeight: tokens.fontWeightRegular,
    textAlign: 'center',
    justifyContent: 'left',
    width: 'fit-content',
    fontSize: tokens.fontSizeBase200,
    minWidth: 'fit-content',
  },
  icon: {
    fontSize: '22px',
    marginRight: tokens.spacingHorizontalSNudge,
  },
});

export const ApplyButton: React.FC<IApplyButtonProps> = ({
  onSave,
  disabled = false,
  tooltipDescription = '',
  tooltipEnabled = false,
}) => {
  const i18n = useContext(I18nContext) as I18nModel;
  const styles = useApplyButtonStyles();

  const [visible, setVisible] = useState(false);
  return (
    <Tooltip
      content={tooltipDescription}
      relationship="description"
      visible={tooltipEnabled && visible}
      onVisibleChange={(_ev, data) => setVisible(data.visible)}
      positioning="below"
    >
      <Button
        onClick={onSave}
        className={mergeClasses('apply-button', styles.button)}
        disabled={disabled}
      >
        <CheckmarkRegular className={styles.icon} />
        {i18n?.getString(_TL_('Confirm'))}
      </Button>
    </Tooltip>
  );
};
